var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2734 3C8.26284 3 5 6.26284 5 10.2734C5 11.5572 5.33918 12.8193 5.98084 13.9233C6.13112 14.1818 6.29712 14.4308 6.47792 14.6689L11.9574 22H12.5894L18.069 14.6689C18.2497 14.4308 18.4157 14.1818 18.566 13.9234C19.2077 12.8193 19.5469 11.5572 19.5469 10.2734C19.5469 6.26284 16.284 3 12.2734 3ZM12.2734 12.6855C10.9434 12.6855 9.86133 11.6035 9.86133 10.2734C9.86133 8.9434 10.9434 7.86133 12.2734 7.86133C13.6035 7.86133 14.6855 8.9434 14.6855 10.2734C14.6855 11.6035 13.6035 12.6855 12.2734 12.6855Z",
    fill: "#E13535"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationImg);
export default __webpack_public_path__ + "static/media/locationImg.b03a29cf0aa3cc66b4182673c07274db.svg";
export { ForwardRef as ReactComponent };